<template>
    <v-dialog
        v-model="shlModal"
        max-width="500px"
    >
        <v-card>
            <v-toolbar color="primary" dense dark>
                <v-toolbar-title>
                    Edit Schedule
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-row>
                    <v-col cols="8">
                        <v-time-picker
                        format="24hr"
                        landscape
                        @click:hour="getAMPM"
                        @click:minute="getAMPM"
                        label="Time"
                        v-model="time"
                        ></v-time-picker>
                        <!-- <v-text-field
                            @change="getAMPM"
                            label="Time"
                            v-mask="'##:##'"
                            v-model="time"
                        ></v-text-field> -->
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-switch 
                            label="Day Off" color="red" v-model="offDay"></v-switch>
                    </v-col>
                </v-row>
                <v-row justify="end">
                        <v-btn @click="saveShd" class="mr-5 mb-3" color="primary">Save</v-btn>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from "axios";
import moment from "moment";
import { mask } from 'vue-the-mask';
export default {
    directives: { mask },
    props:['event','shlModal'],
    data: function(){
        return {
            time:null,
            shift:null,
            offDay:null,
        }
    },
    
    mounted() {
        console.log(this.event);
        this.offDay = this.event.dayOff;
        this.time = this.event.time;
        this.shift = this.event.shift;
    },
    methods:{
        saveShd:async function(){
                var str = this.$store;
                console.log('put', this.event);
                if(this.event.register){
                const parms =   {
                    HourStart: this.event.time + ":00",
                    EndDate: this.event.end,
                    DayOff: this.event.dayOff,
                    Shift: this.shift
                }
                str.state.isLoading = true;
                axios
                .put('schedule/' + this.event.id ,parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    str.state.isLoading = false;
                        if(this.offDay){
                            this.event.dayOff = 1;
                            this.event.color = "red";
                            this.event.name = "DayOff";
                            this.event.time = this.time;
                        }else{
                            this.event.dayOff = 0;
                            this.event.color = this.shift == "AM" ? '#00695C':"#01579b";
                            this.event.name = 'StartTime ' + this.time + '  Shift :' + this.shift;
                            this.event.time = this.time;
                            this.event.start =  this.event.date +' '+this.time;
                            this.event.shift = this.shift;
                        }
                        this.$emit('close');
                    })
                    .catch(function (error) {
                        str.state.isLoading = false;
                        console.log(error);
                    });
                }else{
                    if(this.offDay){
                            this.event.dayOff = 1;
                            this.event.color = "#78909C";
                            this.event.name = "DayOff";
                            this.event.time = this.time;
                        }else{
                            this.event.dayOff = 0;
                            this.event.color = '#78909C';
                            this.event.name = 'StartTime ' + this.time + '  Shift :' + this.shift;
                            this.event.time = this.time;
                            this.event.shift = this.shift;
                        }
                        this.$emit('close');
                }
        },
        recalculateHrs: function(){
            const start =  moment(this.time); 
            console.log(start);
        },
        getAMPM: function () {
            const endTime = moment(this.event.date + " " + this.time);
            // console.log(endTime,this.event.workHrs,this.time);
            const hora = endTime.add(this.event.workHrs, 'hours');
            console.log(this.event.date + " " + this.time ,hora.format('YYYY-MM-DD HH:mm'))
            this.event.end = hora.format('YYYY-MM-DD HH:mm');
            const [hours, minutes] = this.time.split(':').map(Number);
            const period = hours >= 12 ? 'PM' : 'AM';
            this.shift = period;
            this.event.time = this.time;
            console.log(this.event.end);
        },
    }
}

</script>